<template>
    <div class="container">
        <div class="section-space-25"></div>
        <div class="section-header-title">Offer Details</div>
        <div class="section-space-25"></div>

        <div v-if="isLoading" class="text-center py-5">
            <component-content-loader />
        </div>

        <div v-else-if="offer" class="offer-detail-wrapper">
            <!-- Left Image -->
            <div class="offer-image">
                <img v-lazy="offer.image_path ? IMAGE_URL + offer.image_path : null" class="lazy-image img-fluid"
                    alt="Offer Image" />
            </div>

            <!-- Right Content -->
            <div class="offer-content">
                <h2 class="offer-title">{{ offer.offer_name }}</h2>
                <div class="offer-description" v-html="offer.offer_description"></div>

                <button class="btn btn-primary w-100 font-weight-bold" @click="goToMovies">Go to Movies</button>
            </div>
        </div>

        <div v-else class="text-center py-5">Offer not found.</div>

        <section>
            <div>
                <div class="section-space-25"></div>
            </div>
        </section>
    </div>
</template>

<script>
import OfferService from "@/apiServices/OfferService";
import { IMAGEURL } from "@/config";

export default {
    data() {
        return {
            IMAGE_URL: IMAGEURL,
            offer: null,
            isLoading: false,
        };
    },
    async beforeMount() {
        const offer_id = this.$route.params.offer_id;
        await this.getOfferData(offer_id);
    },
    methods: {
        async getOfferData(offer_id) {
            this.isLoading = true;
            try {
                const response = await OfferService.GetOfferData({ offer_id });
                if (response.data.status) {
                    this.offer = response.data.data;
                }
            } catch (err) {
                console.error("Error fetching offer details:", err);
            } finally {
                this.isLoading = false;
            }
        },
        goToMovies() {
            this.$router.push("/movies");
        },
    },
};
</script>

<style scoped>
.offer-detail-wrapper {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 30px;
    background: var(--bg-dark-2);
    padding: 30px;
    border-radius: 12px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}

.offer-image img {
    width: 300px;
    max-width: 100%;
    border-radius: 10px;
    object-fit: inherit;
}

.offer-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    color: #fff;
}

.offer-title {
    font-size: 26px;
    font-weight: 700;
    color: #BE7B78;
    margin-bottom: 15px;
}

.offer-description {
    font-size: 16px;
    line-height: 1.6;
    color: #d0d0d0;
    text-align: justify;
}

/* Responsive */
@media (max-width: 768px) {
    .offer-detail-wrapper {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/offerDetail.vue